import { Navigate, useLocation } from 'react-router-dom'

/**
 *
 * @param Component
 * @returns Redirects to dashboard if user is logged in
 */
export const CheckUserSignup = ({ children }) => {
  const location = useLocation()
  let user = JSON.parse(localStorage.getItem('user-signup'))
  if (!user) {
    return (
      <Navigate
        to="/"
        state={{ path: location.pathname }}
      />
    )
  }

  return children
}
